import CityPageTemplate from "../city-template/CityPageTemplate";
import { usviConfig } from "./data";

export default function UsviPage() {
  return <CityPageTemplate config={usviConfig} />;
}